module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"forgetPasswordtitle":"Request reset password","messages":{"successTitle":"Email sent","successMsg":"Please reset the password according to the email"}},"zh_hk":{"forgetPasswordtitle":"要求重設密碼","messages":{"successTitle":"郵件已發送","successMsg":"請根據電子郵件重設密碼"}},"zh_cn":{"forgetPasswordtitle":"要求重设密码","messages":{"successTitle":"邮件已发送","successMsg":"请根据电子邮件重设密码"}}}')
  delete Component.options._Ctor
}
